import React, { useState, useEffect } from "react";
import { useSupabase } from '../context/SupabaseContext';
import Goals from "../components/Goals";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var moment = require('moment');
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  ProgressBar,
  Container,
  Row,
  Col,
} from "react-bootstrap";

function Maps() {

  const { goals, addGoal, removeGoal, updateGoalProgress, markGoalCompleted } = useSupabase();
  const [newGoalName, setNewGoalName] = useState("");
  const [newGoalTarget, setNewGoalTarget] = useState("");
  const [newGoalDescription, setNewGoalDescription] = useState("");
  const [newGoal, setNewGoal] = useState("");
  const [newtargetAmount, setNewtargetAmount] = useState("");
  const [newcurrentAmount, setNewcurrentAmount] = useState("");
  const [newendDate, setNewendDate] = useState("");
  const [newcompleted, setNewcompleted] = useState("");

  const notifySuccess = (message) => toast.success(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  const notifyFailure = ()=>toast.error("An Error Occured", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const newGoalData = { goal: newGoal, targetAmount: newtargetAmount, currentAmount: newcurrentAmount, endDate: newendDate, completed: false };

  const fetchGoals = async () => {
    // Disabled - using global state instead
    console.log('fetchGoals disabled - using global state');
  }
  const createNewGoal = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!newGoalName?.trim()) {
      console.error('Goal description is required');
      notifyFailure();
      return;
    }
    
    if (!newtargetAmount || isNaN(parseFloat(newtargetAmount)) || parseFloat(newtargetAmount) <= 0) {
      console.error('Valid target amount is required (must be > 0)');
      notifyFailure();
      return;
    }
    
    const goalData = {
      name: newGoalName.trim(),
      target_amount: parseFloat(newtargetAmount),
      current_amount: parseFloat(newcurrentAmount) || 0,
      target_date: newendDate || null
    };
    
    console.log('Goal form data:', goalData);
    
    try {
      // Add to Supabase
      console.log('Calling addGoal...');
      const result = await addGoal(goalData);
      
      console.log('Add goal result:', result);
      
      if (result.success) {
        // Clear form fields
        setNewGoalName('');
        setNewtargetAmount('');
        setNewcurrentAmount('');
        setNewendDate('');
        
        notifySuccess("Goal added successfully");
      } else {
        notifyFailure();
      }
    } catch (e) {
      console.error("Error adding goal:", e);
      notifyFailure();
    }
  }
  const deleteOneGoal = async (goals_id)=>{
    console.log("trying to delete")
    try {
      // Remove from Supabase
      const result = await removeGoal(goals_id);
      
      if (result.success) {
        notifySuccess("Successfully Deleted")
      } else {
        notifyFailure()
      }
    } catch (e) {
      console.error("Error deleting goal:", e);
      notifyFailure()
    }
  }
  const updateCurrentAmount = async(id,amount)=>{
    try {
      // Update in Supabase using the context function
      const result = await updateGoalProgress(id, amount);
      
      if (result.success) {
        notifySuccess("Successfully Updated")
      } else {
        notifyFailure()
      }
    } catch (e) {
      console.error("Error updating goal:", e);
      notifyFailure()
    }
  }
  const markCompleted=async(id)=>{
    try {
      // Update goal in Supabase using the context function
      const result = await markGoalCompleted(id);
      
      if (result.success) {
        notifySuccess("Goal Completed Successfully")
      } else {
        notifyFailure()
      }
    } catch (e) {
      console.error("Error completing goal:", e);
      notifyFailure()
    }
  }

  useEffect(() => {
    // Disabled - using global state instead
    console.log('useEffect disabled - using global state');
  }, [])
  /* { goal: newGoal, targetAmount: newtargetAmount, currentAmount: newcurrentAmount, endDate: newendDate, completed: false } */

  return (
    <>
      <ToastContainer />
      <Container fluid>
        <Row>
          <Col md="12">
          {goals?.map((goal,index)=>{
            return (
              <Goals
              goal={goal.name}
              targetAmount={goal.target_amount}
              currentAmount={goal.current_amount}
              endDate={goal.target_date || new Date().toISOString()}
              completed={goal.completed}
              startDate={goal.created_at || new Date().toISOString()}
              goals_id={goal.id}
              updateAmount={updateCurrentAmount}
              deleteGoal={deleteOneGoal}
              markCompleted={markCompleted}
              />
            )
          })}
          </Col>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Add New Goal</Card.Title>
                <p className="card-category">
                  This will help you to manage your finance goals.
                </p>
              </Card.Header>
              <Form>
                <Row>
                  <Col className="pl-4" md="6">
                    <Form.Group>
                      <label>Goal Description</label>
                      <Form.Control
                        placeholder="Goal aim"
                        type="text"
                        value={newGoalName}
                        required
                        onChange={(e)=>setNewGoalName(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col className="pl-1" md="5">
                    <Form.Group style={{marginLeft:"1rem"}}>
                      <label>Deadline</label>
                      <Form.Control
                        placeholder="Date"
                        type="date"
                        onChange={(e)=>setNewendDate(e.target.valueAsDate)}
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="pl-4" md="6">
                    <Form.Group>
                      <label>Currently Saved</label>
                      <Form.Control
                        placeholder="Goal amount"
                        type="number"
                        value={newcurrentAmount}
                        onChange={(e)=>setNewcurrentAmount(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col className="pl-1" md="5">
                    <Form.Group style={{marginLeft:"1rem"}}>
                      <label>Target Amount</label>
                      <Form.Control
                        placeholder="Goal amount"
                        type="number"
                        value={newtargetAmount}
                        onChange={(e)=>setNewtargetAmount(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="d-grid gap-2 pl-2">
                  <Button className="btn-fill pull-right" variant="success" onClick={createNewGoal}>
                    Add Goal
                  </Button>
                </div>
                <br></br>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Maps;
